import React, { useState } from "react";
import PropTypes from "prop-types";

function LazyYouTube({ videoId, title }) {
  const [showIframe, setShowIframe] = useState(false);
  return showIframe ? (
    <iframe
      src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
      style={{ width: "100%", height: "315px" }}
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      title={title}
    />
  ) : (
    <div
      className="youtube-facade"
      style={{
        position: "relative",
        width: "100%",
        height: "315px",
        background: "#000",
        cursor: "pointer",
      }}
      onClick={() => setShowIframe(true)}
      tabIndex={0}
      aria-label="Play video"
      role="button"
    >
      <img
        src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
        alt={title}
        style={{ width: "100%", height: "100%", objectFit: "cover" }}
        loading="lazy"
      />
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%,-50%)",
          width: 64,
          height: 64,
          background: "rgba(0,0,0,0.6)",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <svg width="40" height="40" viewBox="0 0 68 48">
          <path
            d="M66.52 7.85a8.27 8.27 0 0 0-5.82-5.83C56.36.67 34 .67 34 .67s-22.36 0-26.7 1.35a8.27 8.27 0 0 0-5.82 5.83A85.4 85.4 0 0 0 0 24a85.4 85.4 0 0 0 1.48 16.15 8.27 8.27 0 0 0 5.82 5.83c4.34 1.35 26.7 1.35 26.7 1.35s22.36 0 26.7-1.35a8.27 8.27 0 0 0 5.82-5.83A85.4 85.4 0 0 0 68 24a85.4 85.4 0 0 0-1.48-16.15z"
            fill="#f00"
          />
          <path d="M45 24 27 14v20z" fill="#fff" />
        </svg>
      </div>
    </div>
  );
}

const Modal = ({ show, videoId }) => {
  if (!show) {
    return null;
  }
  return (
    <div className="modal-body">
      <LazyYouTube videoId={videoId} title={`YouTube video: ${videoId}`} />
    </div>
  );
};

Modal.propTypes = {
  show: PropTypes.bool.isRequired,
  videoId: PropTypes.string.isRequired,
};

export default Modal;
